import React from "react";
// import { LangTranslate } from "../../services/types/translate.types";
// import {
//   useLazyGetTranslationQuery,
//   useSaveTranslationMutation,
// } from "../../services/api/admin";
// import TablePopup from "../table-popup/tablePopup";
// import TranslationPopup from "../translationPopup/translationPopup";
// import { useDispatch, useSelector } from "react-redux";
// // import { setListTranslate } from '../../services/slices/admin.slice'
// // import cloneDeep from 'lodash/cloneDeep';
// import { UpdateTranslationsRequest } from "../../services/types/translate.types";
// import Loader from "../loader/loader";
// import GeneralSuccessPopup from "../generalSuccessPopup/generalSuccessPopup";
// // import GeneralErrorPopup from '../errorPopup/errorPopup';
// import Modal from "../modal/Modal";
// import { adminListSelector } from "../../services/selectors/admin.selectors";
// import { result } from 'lodash';

interface Props {
  translationKey: string;
  text: string;
  onClose: () => void;
}

const AdminTextEditor: React.FC<Props> = (
  {
    // translationKey,
    // text,
    // onClose,
  }
) => {
  // const [getTranslation] = useLazyGetTranslationQuery();
  // const [saveTranslation] = useSaveTranslationMutation();
  // const [success, setSuccess] = useState(false);
  // const [textChange, setTextChange] = useState("");
  // const [data, setData] = useState<LangTranslate[] | null>(null);
  // const [translationsListFiltered, setTranslationsListFiltered] = useState<
  //   LangTranslate[] | null
  // >(null);
  // const [isLoading, setIsLoading] = useState(false);
  // const [error, setError] = useState(false);
  // const [showTranslationPopup, setShowTranslationPopup] = useState(true);
  // const [showTablePopup, setShowTablePopup] = useState(false);
  // const dispatch = useDispatch();
  // const hasInitialized = useRef(false);
  // const LangTranslateArr = useSelector(adminListSelector);
  //
  // useEffect(() => {
  //   console.log("adminText");
  //
  //   if (textChange !== "") {
  //     setIsLoading(true);
  //     getTranslation(textChange)
  //       .unwrap()
  //       .then((response) => {
  //         setData(response);
  //         // dispatch(setListTranslate(response));
  //       })
  //       .catch((err) => {
  //         setError(true);
  //         console.error("שגיאה בקריאה לשרת:", err);
  //       })
  //       .finally(() => setIsLoading(false));
  //   }
  // }, [textChange]);
  //
  // useEffect(() => {
  //   if (data && !hasInitialized.current) {
  //     const filtered = data.filter(
  //       (item) => item.language?.trim() && item.translate?.trim()
  //     );
  //     setTranslationsListFiltered(filtered);
  //
  //     setShowTranslationPopup(false);
  //     setShowTablePopup(true);
  //     hasInitialized.current = true;
  //   }
  // }, [data]);
  //
  // async function onSaveSingle(lang: string, value: string): Promise<boolean> {
  //   setShowTablePopup(false);
  //   setShowTranslationPopup(false);
  //   try {
  //     if (!lang || !value) {
  //       setError(true);
  //       console.error("שדה השפה או התרגום חסר");
  //       return false;
  //     }
  //
  //     const req: UpdateTranslationsRequest = {
  //       translationsList: [
  //         {
  //           language: localStorage.getItem("i18nextLng") || "he",
  //           translate: value,
  //           code: localStorage.getItem("i18nextLng") || "he",
  //         },
  //       ],
  //       key: translationKey,
  //     };
  //
  //     const result = await saveTranslation(req).unwrap();
  //     setSuccess(true);
  //     setTimeout(() => {
  //       console.log("gv");
  //     }, 7000);
  //     return result;
  //   } catch (error) {
  //     setShowTranslationPopup(false);
  //     setError(true);
  //     console.error("שגיאה בשמירה:", error);
  //     return false;
  //   }
  // }
  //
  // async function onSaveAll(): Promise<boolean> {
  //   setShowTablePopup(false);
  //   try {
  //     if (!LangTranslateArr) {
  //       setError(true);
  //       return false;
  //     }
  //
  //     const req: UpdateTranslationsRequest = {
  //       key: translationKey,
  //       translationsList: LangTranslateArr,
  //     };
  //     const result = await saveTranslation(req).unwrap();
  //     setSuccess(true);
  //     setTimeout(() => {
  //       console.log("suc");
  //     }, 9000);
  //
  //     return result;
  //   } catch (error) {
  //     setError(true);
  //     setShowTablePopup(false);
  //     console.error("שגיאה בשמירה:", error);
  //     return false;
  //   }
  // }
  //
  // function onTranslate(text: string): void {
  //   setTextChange(text);
  // }
  //
  // function closeAllPopups() {
  //   setShowTablePopup(false);
  //   setShowTranslationPopup(false);
  //   onClose();
  // }
  // useEffect(() => {
  //   const handler = (e: BeforeUnloadEvent) => {
  //     e.preventDefault();
  //     e.returnValue = "";
  //   };
  //   window.addEventListener("beforeunload", handler);
  //   return () => window.removeEventListener("beforeunload", handler);
  // }, []);

  return <div />;
  //   <>
  //     {/* {error && !success && <Modal onClose={() => setError(false)}><GeneralErrorPopup onClose={() => setError(false)} /></Modal>} */}
  //     {isLoading && <Loader fullscreen />}
  //     {success && (
  //       <Modal onClose={() => setSuccess(false)}>
  //         <GeneralSuccessPopup
  //           onClose={() => {
  //             setSuccess(false);
  //             closeAllPopups();
  //           }}
  //         />
  //       </Modal>
  //     )}
  //
  //     {showTranslationPopup && (
  //       <TranslationPopup
  //         translationKey={translationKey}
  //         text={text}
  //         onClose={() => setShowTranslationPopup(false)}
  //         onTranslate={onTranslate}
  //         onSave={onSaveSingle}
  //         onSaveAll={onSaveAll}
  //       />
  //     )}
  //
  //     {showTablePopup && (
  //       <TablePopup
  //         onSaveAll={onSaveAll}
  //         onClose={() => setShowTablePopup(false)}
  //       />
  //     )}
  //   </>
  // );
};

export default AdminTextEditor;
